export const triggerCsvDownload = (name: string, rows: (string | number)[][]) => {
  const csvContent = `data:text/csv;charset=utf-8,${rows.map((e) => e.join(',')).join('\n')}`;
  const encodedUri = encodeURI(csvContent);

  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportCsv = <
  T,
  R extends (string | number | undefined)[] = (string | number | undefined)[],
>({
  name,
  headers = [],
  getExportableData,
  getRow,
}: {
  name: `${string}.csv`;
  headers?: string[];
  getExportableData: () => Record<string, Record<string, T>>;
  getRow: (date: string, id: string, data: T) => R;
}) => {
  const exportableData = getExportableData();

  const rows: R[] = [];
  const dates = Object.keys(exportableData);

  for (const date of dates) {
    const statData = exportableData[date];
    Object.entries(statData ?? {}).forEach(([id, data]) => {
      rows.push(getRow(date, id, data));
    });
  }

  const columnCount = Math.max(...rows.map((r) => r.length));
  const keepColumn = Array.from({ length: columnCount }, (_, i) =>
    rows.some((row) => row[i] !== undefined),
  );

  const cleanedRows = rows.map(
    (row) => row.filter((_, i) => keepColumn[i]) as Exclude<R[number], undefined>[],
  );

  const cleanedHeaders = headers.filter((_, i) => keepColumn[i]);

  triggerCsvDownload(name, [cleanedHeaders, ...cleanedRows]);
};
